<ion-item lines="none" [title]="lockIndicator === true ? lockTitle : ''">
  <ion-label *ngIf="!hideLabel" position="stacked" [class.disabled]="disabled">
    <ion-icon *ngIf="lockIndicator" slot="start" [name]="(disabled) ? 'lock-closed-outline' : 'lock-open-outline'" class="no-pointer-evts"></ion-icon>
    {{ label + (required ? '*' : '')  }}
  </ion-label>
  <ion-row class="w100pct" [id]="id">
    <ion-col size-sm="6" *ngIf="type === 'date' || type === 'datetime'">
      <input [disabled]="disabled" [class.disabled]="disabled" [(ngModel)]="inputDate" type="date" (ngModelChange)="inputChange()"
        displayFormat="MMM DD, YYYY" pickerFormat="DD MMM YYYY" [min]="minDate" />
    </ion-col>
    <ion-col size-sm="6" *ngIf="type === 'time' || type === 'datetime'">
      <input [disabled]="disabled" [class.disabled]="disabled" [(ngModel)]="inputTime" type="time" (ngModelChange)="inputChange()"
        displayFormat="h:mm A" pickerFormat="h mm A" />
    </ion-col>
  </ion-row>
</ion-item>
